import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B, tap } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { successToast, errorToast } from "../Toasts.jsx";
import { startAsPromise } from "../fable_modules/fable-library-js.4.24.0/Async.js";
import { toastServerError, Track } from "../ApiClient.jsx";
import { createElement } from "react";
import React from "react";
import { useCtx } from "../Context.jsx";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { DialogBody, DialogActions, tokens, Image, Textarea, Input, Field, DialogContent, DialogTitle, DialogSurface, Button, DialogTrigger, Dialog } from "@fluentui/react-components";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { ImageAddRegular, AddRegular } from "@fluentui/react-icons";
import { take, length, tryHead, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { Browser_Types_File__File_ReadAsByteArray } from "../fable_modules/Fable.Remoting.Client.7.35.0/Extensions.fs.js";
import { NewTrack, S3UploadFile } from "../Shared/SharedModels.jsx";

function addTrack(form, callback, setCtx) {
    const pr = tap((res) => {
        if (res.tag === 1) {
            switch (res.fields[0].tag) {
                case 1: {
                    errorToast(setCtx, "addTrackErrorValidationFailed", "Kunne ikke opprette kursløp", "Noen felter er tomme eller ugyldige", undefined);
                    break;
                }
                case 2: {
                    errorToast(setCtx, "addTrackErrorUploadImageError", "Kunne ikke opprette kursløp", "Noe gikk galt ved bildeopplastning", undefined);
                    break;
                }
                default:
                    errorToast(setCtx, "addTrackErrorConflict", "Kunne ikke opprette kursløp", "Det finnes allerede kursløp med dette navnet", undefined);
            }
        }
        else {
            const track = res.fields[0];
            callback(track);
            successToast(setCtx, `addTrackSuccess${track.Id}`, "Kursløp opprettet", `Kursløp ${track.Name} ble opprettet`);
        }
    }, startAsPromise(Track.Add(form)));
    void (pr.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

export function CreateTrackDialog(createTrackDialogInputProps) {
    let elems_7, el_4, el_2, el, el_36, elems_6, props_53, el_6, el_26, elems_4, el_11, el_16, elems_3, el_34, elems_5, el_30, el_28, el_32, name_5, elemsToUse;
    const callback = createTrackDialogInputProps.callback;
    const patternInput = useCtx();
    const patternInput_1 = reactApi.useState("");
    const name = patternInput_1[0];
    const patternInput_2 = reactApi.useState("");
    const description = patternInput_2[0];
    const patternInput_3 = reactApi.useState(false);
    const patternInput_4 = reactApi.useState(false);
    const patternInput_5 = reactApi.useState(undefined);
    const setFile = patternInput_5[1];
    const file = patternInput_5[0];
    const patternInput_6 = reactApi.useState(undefined);
    const setImg = patternInput_6[1];
    const img = patternInput_6[0];
    const patternInput_7 = reactApi.useState(false);
    const setIsOpen = patternInput_7[1];
    const el_38 = Dialog;
    return createElement(el_38, createObj(ofArray([["open", patternInput_7[0]], ["onOpenChange", (_arg, value_1_1) => {
        setIsOpen(value_1_1.open);
    }], (elems_7 = [(el_4 = DialogTrigger, createElement(el_4, {
        disableButtonEnhancement: true,
        children: (el_2 = Button, createElement(el_2, {
            appearance: "primary",
            children: "Opprett kursløp",
            icon: (el = AddRegular, createElement(el, {})),
        })),
    })), (el_36 = DialogSurface, createElement(el_36, createObj(singleton_1((elems_6 = [(props_53 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        as: "h1",
        children: "Opprett kursløp",
    })), (el_26 = DialogContent, createElement(el_26, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 15 + "px ",
    }], (elems_4 = [(el_11 = Field, createElement(el_11, createObj(toList(delay(() => append(patternInput_3[0] ? append(singleton(["validationMessage", "Navn kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => append(singleton(["label", "Navn"]), delay(() => {
        let matchValue, el_8;
        return singleton(["children", (matchValue = tryHead([(el_8 = Input, createElement(el_8, {
            placeholder: "ADHD barn 4-6 år",
            onChange: (_arg_1, value_1_10) => {
                const v = value_1_10;
                patternInput_1[1](v.value);
                patternInput_3[1](isNullOrWhiteSpace(v.value));
            },
        }))]), (matchValue == null) ? defaultOf() : matchValue)]);
    }))))))))), (el_16 = Field, createElement(el_16, createObj(toList(delay(() => append(singleton(["label", "Beskrivelse"]), delay(() => append(patternInput_4[0] ? append(singleton(["validationMessage", "Beskrivelse kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
        let matchValue_1, el_13;
        return singleton(["children", (matchValue_1 = tryHead([(el_13 = Textarea, createElement(el_13, {
            value: description,
            onChange: (_arg_2, value_1_14) => {
                const v_1 = value_1_14;
                patternInput_2[1](v_1.value);
                patternInput_4[1](isNullOrWhiteSpace(v_1.value));
            },
        }))]), (matchValue_1 == null) ? defaultOf() : matchValue_1)]);
    }))))))))), createElement("input", {
        id: "image-select-input-create-track",
        type: "file",
        accept: "image/png, image/jpeg",
        onChange: (ev) => {
            const files = ev.target.files;
            if (!(files == null) && (files.length > 0)) {
                const f = files.item(0);
                const reader = new FileReader();
                reader.onload = ((_arg_3) => {
                    const matchValue_2 = reader.result;
                    if (typeof matchValue_2 === "string") {
                        const base64data = matchValue_2;
                        setFile(f);
                        setImg(base64data);
                    }
                });
                reader.readAsDataURL(f);
            }
        },
        style: {
            display: "none",
        },
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
    }], (elems_3 = toList(delay(() => {
        let i, el_18, el_24, elems_2, el_22;
        return (file != null) ? ((img != null) ? ((i = img, append(singleton((el_18 = Image, createElement(el_18, {
            style: {
                width: 95 + "%",
                maxWidth: 400,
                maxHeight: 250,
                minHeight: 150,
            },
            fit: "contain",
            src: i,
        }))), delay(() => {
            let el_20;
            return singleton((el_20 = Button, createElement(el_20, {
                children: "Slett",
                size: "small",
                onClick: (_arg_4) => {
                    setFile(undefined);
                    setImg(undefined);
                },
                appearance: "transparent",
            })));
        })))) : singleton((el_24 = Button, createElement(el_24, createObj(ofArray([["onClick", (_arg_5) => {
            document.getElementById("image-select-input-create-track").click();
        }], ["style", {
            width: 95 + "%",
            maxWidth: 400,
            maxHeight: 250,
            minHeight: 150,
            borderStyle: "dashed",
            borderColor: tokens.colorBrandBackgroundStatic,
            borderWidth: 1,
        }], (elems_2 = [(el_22 = ImageAddRegular, createElement(el_22, {
            fontSize: 48,
            primaryFill: tokens.colorBrandForeground2,
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])))))) : singleton((el_24 = Button, createElement(el_24, createObj(ofArray([["onClick", (_arg_5) => {
            document.getElementById("image-select-input-create-track").click();
        }], ["style", {
            width: 95 + "%",
            maxWidth: 400,
            maxHeight: 250,
            minHeight: 150,
            borderStyle: "dashed",
            borderColor: tokens.colorBrandBackgroundStatic,
            borderWidth: 1,
        }], (elems_2 = [(el_22 = ImageAddRegular, createElement(el_22, {
            fontSize: 48,
            primaryFill: tokens.colorBrandForeground2,
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])])))), (el_34 = DialogActions, createElement(el_34, createObj(ofArray([["position", "end"], (elems_5 = [(el_30 = DialogTrigger, createElement(el_30, {
        disableButtonEnhancement: true,
        children: (el_28 = Button, createElement(el_28, {
            appearance: "secondary",
            children: "Lukk",
        })),
    })), (el_32 = Button, createElement(el_32, {
        disabled: isNullOrWhiteSpace(name) ? true : isNullOrWhiteSpace(description),
        appearance: "primary",
        children: "Send",
        onClick: (_arg_6) => {
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let file_1;
                return ((file_1 = file, PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    if (file_1 != null) {
                        const f_1 = file_1;
                        return startAsPromise(Browser_Types_File__File_ReadAsByteArray(f_1)).then((_arg_7) => {
                            let res;
                            const MimeType = f_1.type;
                            res = (new S3UploadFile(f_1.name, MimeType, _arg_7));
                            return Promise.resolve(res);
                        });
                    }
                    else {
                        return Promise.resolve(undefined);
                    }
                })))).then((_arg_8) => {
                    addTrack(new NewTrack(name, description, _arg_8), (newTrack) => {
                        callback(newTrack);
                        setIsOpen(false);
                    }, patternInput[1]);
                    return Promise.resolve();
                });
            }));
            void pr;
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])]))))]), (name_5 = DialogBody, createElement(name_5, {
        children: reactApi.Children.toArray(Array.from(props_53)),
    })))], ["children", reactApi_1.Children.toArray(Array.from(elems_6))])))))], (elemsToUse = ((length(elems_7) <= 2) ? elems_7 : take(2, elems_7)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

//# sourceMappingURL=CreateTrack.jsx.map
